export function tint(hex, amt = 0.9) {
  try {
    const h = (hex || '#0D9488').replace('#', '');
    const n = parseInt(h.length === 3 ? h.split('').map((c) => c + c).join('') : h, 16);
    let r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    r = Math.round(r + (255 - r) * amt); g = Math.round(g + (255 - g) * amt); b = Math.round(b + (255 - b) * amt);
    return `rgb(${r},${g},${b})`;
  } catch { return '#f1f5f9'; }
}

export function darken(hex, amt = 0.2) {
  try {
    const h = (hex || '#0D9488').replace('#', '');
    const n = parseInt(h.length === 3 ? h.split('').map((c) => c + c).join('') : h, 16);
    const r = Math.round(((n >> 16) & 255) * (1 - amt)), g = Math.round(((n >> 8) & 255) * (1 - amt)), b = Math.round((n & 255) * (1 - amt));
    return `rgb(${r},${g},${b})`;
  } catch { return '#0f172a'; }
}
